module.exports = __webpack_public_path__ + "static/laboral-edcf5f52a4e75b71844aa6f70bd53670.png";